import { render, staticRenderFns } from "./bestOfTheBest.vue?vue&type=template&id=78a3527b&"
import script from "./bestOfTheBest.vue?vue&type=script&lang=js&"
export * from "./bestOfTheBest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports